module.exports = __webpack_public_path__ + "static/media/lean.b0ec6bf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/thumbs/lean.jpg
// module id = 236
// module chunks = 0